import { setOrganizations } from '../redux/actions/organizationActions';
import api from './api';

export const getAllOrganizations = () => {
  return (dispatch) => {
    api.get('/api/v1/organizations').then((organizations) => {
      dispatch(setOrganizations(organizations));
    });
  };
};
